import { ModelBase } from 'store/model-base';
import { CustomersDetails } from './customer-details';
import { UserRoles } from 'my-account/constants';

export class ProfileLines extends ModelBase {
    public static storeName: string = 'profileLines';
    public customers: CustomersDetails[];
    public unassociatedLines: UnassociatedLine[];

    public get primaryOrManagerCustomers(): CustomersDetails[] | undefined {
        if (!this.customers) return undefined;

        return this.customers.filter((c: CustomersDetails) => 
            c.role?.toUpperCase() === UserRoles.OWNER || c.role?.toUpperCase() === UserRoles.MANAGER
        );
    }

    public get memberOrViewerCustomers(): CustomersDetails[] | undefined {
        if (!this.customers) return [];

        return this.customers.filter((c: CustomersDetails) =>
            c.role?.toUpperCase() === UserRoles.MEMBER || c.role?.toUpperCase() === UserRoles.VIEWER
        );
    }

    public static create<T extends ModelBase>(data: ApiResponse): T {
       
        return super.create<T>(data);
    }

}
